/* eslint-disable react/no-unused-prop-types */
// propTypes are used in the parent component
import PropTypes from 'prop-types';
import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withMarginBottomZeroToSm, withMarginBottomXl} from '@/hocs/withSpacing';
import Link from '@/links';
import {SectionPadding} from '@/section';
import {H2, P} from '@/typography';
import {useTranslations} from 'next-intl';
import styles from './styles.module.scss';

const CtaDefaultMarginedMob = withMarginBottomZeroToSm(Link);
const H2MarginedXl = withMarginBottomXl(H2);

const assetVersion = process.env.ASSET_VERSION || 'defaultVersion';

const propTypes = {
  backgroundImg: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  colLg: PropTypes.number,
  children: PropTypes.node
};

const DefaultLinks = () => {
  const t = useTranslations('shared');
  return (
    <ul className={styles['list-inline-to-bl']}>
      <li>
        <CtaDefaultMarginedMob
          href="/free-trial"
          variant="secondary-sm-trans-border"
          customAttributes={{
            'data-gtm': 'prefooter-button',
            'data-ui': 'prefooter-free-trial'
          }}>
          {t('freeTrialCTALabel')}
        </CtaDefaultMarginedMob>
      </li>
      <li>
        <Link
          href="/demo"
          variant="primary-sm"
          customAttributes={{
            'data-gtm': 'prefooter-button-demo',
            'data-ui': 'prefooter-demo'
          }}>
          {t('demoCTALabel')}
        </Link>
      </li>
    </ul>
  );
};

const getDefaultProps = () => {
  const t = useTranslations('shared');
  return {
    backgroundImg: `prefooter-bg.jpg?v=${assetVersion}`,
    title: t('preFooterDefault.title'),
    subtitle: t.rich('preFooterDefault.subtitle', {
      br: () => <br />
    }),
    children: <DefaultLinks />
  };
};

const PreFooter = props => {
  const t = useTranslations('shared');
  const defaultProps = getDefaultProps();
  const {backgroundImg, title, subtitle, colLg = 7, children} = {
    ...defaultProps,
    ...props
  };

  return (
    <div className={styles.prefooter}>
      <img
        className={styles.prefooter__img}
        loading="lazy"
        src={`/static/images/prefooter/${backgroundImg}`}
        alt={t('preFooterDefault.imageAlt')}
      />
      <SectionPadding className={styles.prefooter__info}>
        <Container>
          <Grid fluid>
            <Row center="xs">
              <Col xs={12} lg={colLg}>
                <H2MarginedXl>{title}</H2MarginedXl>
                {subtitle ? <P>{subtitle}</P> : null}
                {children}
              </Col>
            </Row>
          </Grid>
        </Container>
      </SectionPadding>
    </div>
  );
};

PreFooter.propTypes = propTypes;

export default PreFooter;
